<template>
  <v-data-table :headers="headers" :items="variables" :search="search" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Variables</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mb-2" v-bind="attrs" v-on="on" @click="resetDialog">Add Variable</v-btn>
          </template>

          <v-card>
            <validation-observer v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(save)" v-if="dialog">
                <v-card-title class="headline grey lighten-2" primary-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          :vid="uuid()"
                          name="Name"
                          :rules="`required|uniqueName:${existingVariableNames}`"
                          v-slot="{ errors }"
                        >
                          <v-text-field label="Name" v-model="editedVariable.name"></v-text-field>

                          <span class="validation-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </v-col>

                      <v-col cols="6">
                        <v-select
                          readonly
                          label="Class"
                          :items="classes"
                          v-model="editedVariable.class"
                        ></v-select>
                      </v-col>

                      <v-col cols="6">
                        <v-select label="Type" :items="typeGroups" v-model="typeGroup"></v-select>
                      </v-col>

                      <v-col cols="6" v-if="typeGroup === 'Base Types'">
                        <validation-provider
                          :vid="uuid()"
                          name="Type"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-select
                            label="Type"
                            :items="baseTypes"
                            v-model="editedVariable.type.name"
                          ></v-select>

                          <span class="validation-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </v-col>

                      <v-col cols="6" v-if="typeGroup === 'User Data Types'">
                        <validation-provider
                          :vid="uuid()"
                          name="Type"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-select
                            label="Type"
                            :items="userDataTypes"
                            v-model="editedVariable.type.derivedName"
                          ></v-select>

                          <span class="validation-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </v-col>

                      <v-col cols="6" v-if="typeGroup === 'Function Block Types'">
                        <validation-provider
                          :vid="uuid()"
                          name="Type"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-select
                            label="Type"
                            :items="functionBlockTypes"
                            v-model="editedVariable.type.name"
                          ></v-select>

                          <span class="validation-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </v-col>

                      <v-col cols="6" v-if="typeGroup === 'Array'">
                        <validation-provider
                          :vid="uuid()"
                          name="Base Type"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-select
                            label="Type"
                            :items="baseTypes"
                            v-model="editedVariable.type.baseType"
                          ></v-select>

                          <span class="validation-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row v-if="typeGroup === 'Array'">
                      <v-col cols="12">
                        <v-data-table
                          :headers="dimensionHeaders"
                          :items="editedVariable.type.dimensions"
                          class="elevation-1"
                        >
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-toolbar-title>Dimensions</v-toolbar-title>

                              <v-spacer></v-spacer>

                              <v-dialog v-model="dimensionDialog" max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="mb-2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="addDimension"
                                  >Add Dimension</v-btn>
                                </template>

                                <v-card>
                                  <validation-observer>
                                    <v-card-title class="headline grey lighten-2" primary-title>
                                      <span class="headline">
                                        {{
                                        dimensionFormTitle
                                        }}
                                      </span>
                                    </v-card-title>

                                    <v-card-text>
                                      <v-container>
                                        <v-row>
                                          <v-col cols="6">
                                            <validation-provider
                                              :vid="uuid()"
                                              name="Lower"
                                              rules="required"
                                              v-slot="{ errors }"
                                            >
                                              <v-text-field
                                                label="Lower"
                                                v-model="editedDimension.lower"
                                              ></v-text-field>

                                              <span class="validation-message">{{ errors[0] }}</span>
                                            </validation-provider>
                                          </v-col>

                                          <v-col cols="6">
                                            <validation-provider
                                              :vid="uuid()"
                                              name="Upper"
                                              rules="required"
                                              v-slot="{ errors }"
                                            >
                                              <v-text-field
                                                label="Upper"
                                                v-model="editedDimension.upper"
                                              ></v-text-field>

                                              <span class="validation-message">{{ errors[0] }}</span>
                                            </validation-provider>
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                      <v-spacer></v-spacer>

                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="resetDimensionDialog()"
                                      >Cancel</v-btn>

                                      <v-btn color="blue darken-1" text @click="saveDimension">Save</v-btn>
                                    </v-card-actions>
                                  </validation-observer>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="editDimension(item)">mdi-pencil</v-icon>
                            <v-icon small @click="deleteDimension(item)">mdi-delete</v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Location" v-model="editedVariable.address"></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field label="Initial Value" v-model="editedVariable.initialValue"></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-select label="Option" :items="options" v-model="editedVariable.option"></v-select>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field label="Documentation" v-model="editedVariable.documentation"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="resetDialog()">Cancel</v-btn>
                  <v-btn color="blue darken-1" text type="submit">Save</v-btn>
                </v-card-actions>
              </form>
            </validation-observer>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editVariable(item)">mdi-pencil</v-icon>
      <v-icon small @click="deleteVariable(item)">mdi-delete</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { find, map, filter } from "lodash";
import uuid from "src/mixins/uuid";
import variables from "src/mixins/variables";

export default {
  name: "ResourceVariables",
  props: ["resourceTempId"],
  mixins: [uuid, variables],
  data() {
    return {
      editedVariable: {
        class: "Global",
        type: {},
      },
      classes: ["Global"],
    };
  },
  computed: {
    variables() {
      return find(this.$store.state.configuration.resources, {
        tempId: this.resourceTempId,
      }).globalVars;
    },
    existingVariableNames() {
      let vars = [];
      const globalVars = find(this.$store.state.configuration.resources, {
        tempId: this.resourceTempId,
      }).globalVars

      if (this.editedVariable.tempId) {
        vars = filter(
          globalVars,
          (globalVar) => globalVar.tempId !== this.editedVariable.tempId
        );
      } else {
        vars = globalVars
      }

      return map(vars, 'name').join(';')
    },
  },
  methods: {
    async deleteVariable(variable) {
      if (
        await this.$confirm("Are you sure you want to delete this variable?")
      ) {
        this.$store.dispatch("deleteResourceVariable", {
          resourceTempId: this.resourceTempId,
          variableTempId: variable.tempId,
        });
      }
    },
    save() {
      if (this.typeGroup === "Array") {
        this.editedVariable.type.name = "array";
      } else if (this.typeGroup === "User Data Types") {
        this.editedVariable.type.name = "derived";
      }

      if (this.editedVariable.tempId) {
        this.$store.dispatch("updateResourceVariable", {
          resourceTempId: this.resourceTempId,
          variable: this.editedVariable,
        });
      } else {
        this.$store.dispatch("addResourceVariable", {
          resourceTempId: this.resourceTempId,
          variable: {
            tempId: this.uuid(),
            ...this.editedVariable,
          },
        });
      }

      this.resetDialog();
    },
    resetDialog() {
      this.dialog = false;
      this.editedVariable = {
        class: "Global",
        type: {},
      };
      this.typeGroup = this.typeGroups[0];
    },
  },
};
</script>
